module.exports = __webpack_public_path__ + "img/ilona-pro.74a31e77.jpg";